import { Component } from '@angular/core';


@Component({
  selector: 'app-base-wireframe',
  templateUrl: './base-wireframe.component.html',
  styleUrls: ['./base-wireframe.component.scss']
})
export class BaseWireframeComponent {}
